import React, {useEffect, useState} from 'react';
import styles from './Account.module.scss'
import Button from "../elements/Button/Button";
import useRandomAvatar from "../../hooks/useRandomAvatar";
import Spinner from "../elements/Spinner/Spinner";
import envelope from '../../assets/svg/envelope.svg';
import addressIcon from '../../assets/svg/address.svg';
import clsx from "clsx";
import useManageUser from "../../hooks/useManageUser";
import Icon from "../elements/Icon/Icon";
import {Link, useNavigate} from "react-router-dom";
import {accountVariants} from "../../utilities/framerVariants";
import {useReducedMotion, motion} from 'framer-motion';
import {useDispatch, useSelector} from "react-redux";
import {getProfile} from "../../store/actions/profileActions";
import Info from "../elements/Info/Info";

const Account = () => {
    document.title = 'Account | Invoice App';
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {profile, loading} = useSelector((state) => state.profile);
    const errors = useSelector((state) => state.errors.profile);
    const {handleUpdateUser, handleUserChange, user, setUser} = useManageUser();
    const {avatar} = useRandomAvatar();
    const [activeTab, setActiveTab] = useState("personalInfo");

    const shouldReduceMotion = useReducedMotion();
    const variant = (element) => {
        return shouldReduceMotion
            ? accountVariants.reduced
            : accountVariants[element];
    };

    const address = user.address || {
        street: "",
        city: "",
        postCode: "",
        country: "",
    };

    const address_ukr = user.address_ukr || {
        street_ukr: "",
        city_ukr: "",
        country_ukr: "",
    }

    const handleChangePassword = () => {
        navigate('/change-password')
    }

    useEffect(() => {
        dispatch(getProfile());
    }, []);

    useEffect(() => {
        if (profile) setUser(profile);
        console.log(profile);
    }, [profile]);

    if (loading) {
        return <Spinner/>
    }

    const renderTabContent = () => {
        if (activeTab === "personalInfo") {
            return (
                <motion.div
                    className={styles.container}
                    variants={variant('form')}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                >
                    <legend className={styles.legend}>Personal Information / Персональна інформація</legend>

                    <div className={styles.columns}>
                        <div className={styles.column1}>
                            <div className={styles.inputContainer}>
                                <label htmlFor="name">Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={user.name}
                                    onChange={(event) => handleUserChange(event, 'name')}
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <label htmlFor="surname">Surname</label>
                                <input
                                    type="text"
                                    name="surname"
                                    value={user.surname}
                                    onChange={(event) => handleUserChange(event, 'surname')}
                                />
                            </div>
                        </div>
                        <div className={styles.column2}>
                            <div className={styles.inputContainer}>
                                <label htmlFor="name_ukr">Ім'я</label>
                                <input
                                    type="text"
                                    name="name_ukr"
                                    value={user.name_ukr}
                                    onChange={(event) => handleUserChange(event, 'name_ukr')}
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <label htmlFor="surname_ukr">Прізвище</label>
                                <input
                                    type="text"
                                    name="surname_ukr"
                                    value={user.surname_ukr}
                                    onChange={(event) => handleUserChange(event, 'surname_ukr')}
                                />
                            </div>
                        </div>

                    </div>

                    <div className={styles.inputContainer}>
                        <label htmlFor="taxNumber">Tax Number / ІПН</label>
                        <input
                            type="text"
                            name="taxNumber"
                            value={user.taxNumber}
                            onChange={(event) => handleUserChange(event, 'taxNumber')}
                        />
                    </div>
                </motion.div>
            );
        }

        if (activeTab === "address") {
            return (
                <motion.div
                    className={styles.container}
                    variants={variant('form')}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                >
                    <div className={styles.info}>
                        <span>Full Address:</span>
                        <p className={styles.infoText}>
                            {address.street || address.city || address.postCode || address.country
                                ? [address.street, address.city, address.postCode, address.country]
                                    .filter(Boolean)
                                    .join(', ')
                                : 'Not available'}
                        </p>
                    </div>
                    <div className={styles.info}>
                        <span>Повна адреса:</span>
                        <p className={styles.infoText}>
                            {address_ukr.street_ukr || address_ukr.city_ukr || address.postCode || address_ukr.country_ukr
                                ? [address_ukr.street_ukr, address_ukr.city_ukr, address.postCode, address_ukr.country_ukr]
                                    .filter(Boolean)
                                    .join(', ')
                                : 'Not available'}
                        </p>
                    </div>
                    <div className={styles.columns}>
                        <div className={styles.column1}>
                            <div className={styles.inputContainer}>
                                <label htmlFor="street">Street</label>
                                <input
                                    type="text"
                                    name="street"
                                    value={user.address?.street || ""}
                                    onChange={(event) => handleUserChange(event, 'address')}
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <label htmlFor="city">City</label>
                                <input
                                    type="text"
                                    name="city"
                                    value={user.address?.city || ""}
                                    onChange={(event) => handleUserChange(event, 'address')}
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <label htmlFor="country">Country</label>
                                <input
                                    type="text"
                                    name="country"
                                    value={user.address?.country || ""}
                                    onChange={(event) => handleUserChange(event, 'address')}
                                />
                            </div>
                        </div>

                        <div className={styles.column2}>
                            <div className={styles.inputContainer}>
                                <label htmlFor="street_ukr">Вулиця</label>
                                <input
                                    type="text"
                                    name="street_ukr"
                                    value={user.address_ukr?.street_ukr || ""}
                                    onChange={(event) => handleUserChange(event, 'address_ukr')}
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <label htmlFor="city_ukr">Місто</label>
                                <input
                                    type="text"
                                    name="city_ukr"
                                    value={user.address_ukr?.city_ukr || ""}
                                    onChange={(event) => handleUserChange(event, 'address_ukr')}
                                />
                            </div>
                            <div className={styles.inputContainer}>
                                <label htmlFor="country_ukr">Країна</label>
                                <input
                                    type="text"
                                    name="country_ukr"
                                    value={user.address_ukr?.country_ukr || ""}
                                    onChange={(event) => handleUserChange(event, 'address_ukr')}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={styles.inputContainer}>
                        <label htmlFor="postCode">Post Code / Поштовий індекс</label>
                        <input
                            type="text"
                            name="postCode"
                            value={user.address?.postCode || ""}
                            onChange={(event) => handleUserChange(event, 'address')}
                        />
                    </div>
                </motion.div>
            );
        }
    };

    if (profile)
        return (
            <div className={styles.account}>
                <div className={styles.banner}
                />
                <motion.div
                    className={styles.mainCard}
                    variants={variant('account')}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                >
                    <Link
                        className={styles.goBack}
                        to="/"
                    >
                        <Icon name={'arrow-left'} size={10}/>
                        Go back
                    </Link>
                    <img
                        src={avatar}
                        alt="Avatar"
                        className={styles.avatar}
                    />
                    <h2 className={styles.name}>
                        {profile.name} {profile.surname}
                    </h2>
                    <Button className={styles.changePassword} onClick={handleChangePassword}>Change Password</Button>
                </motion.div>
                <motion.div
                    className={styles.detailsCard}
                    variants={variant('account2')}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                >
                    <div className={styles.tabsContainer}>
                        <div className={styles.topBlock}>
                            <div className={styles.tabs}>
                                <button
                                    className={clsx(styles.tab, {[styles.active]: activeTab === "personalInfo"})}
                                    onClick={() => setActiveTab("personalInfo")}
                                >
                                    Personal Information
                                </button>
                                <button
                                    className={clsx(styles.tab, {[styles.active]: activeTab === "address"})}
                                    onClick={() => setActiveTab("address")}
                                >
                                    Address
                                </button>
                            </div>
                            <Info paragraphs={[
                                'Your personal information is used to generate invoices.',
                                'You can update your personal information at any time.',
                                'Please, make sure your information is correct and up to date.'
                            ]}
                            />
                        </div>

                        <motion.div
                            className={styles.detailsCard}
                            variants={variant('account2')}
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                        >
                            <form className={styles.form}>
                                {renderTabContent()}
                            </form>
                        </motion.div>
                    </div>
                    <div className={styles.bottomBlock}>
                        <Button
                            className='primary'
                            onClick={() => handleUpdateUser(() => dispatch(getProfile))}
                            disabled={loading}
                        >
                            {loading ? 'Saving...' : 'Save'}
                        </Button>
                    </div>
                </motion.div>
            </div>
        );
};

export default Account;
